export const MATCH_TYPE_OPTIONS = [
	{ label: 'Equal', value: 'equal' },
	{ label: 'Not Equal', value: 'not_equal' },
	{ label: 'Regex', value: 'regex' },
];
